import React from 'react';
import { useContextSelector } from 'use-context-selector';

import { PAGES } from '../../Router/pages';
import { ModuleContext } from '../../contexts/ModuleContext';

import {
  fetchActiveServices,
  fetchCatalogService,
  fetchExternalClientServices,
  fetchProductById,
  fetchServiceById
} from '../../modules/products';

import HeadTitle from '../../components/HeadTitle';
import ContainerPage from '../../components/ContainerPage';
import Button from '../../components/Button';
import LoadingOverlay from '../../components/LoadingOverlay';
import Search from './components/Search';

import * as S from './styles';
import { Resources } from '../../models/ScheduleResource';
import { fetchSpecialistById, fetchSpecialists, fetchSpecialties } from '../../modules/specialists';
import { SpecialistList as Specialist } from '../../models/Specialist';
import { ServiceItemProps } from '../../models/Service';
import { ProductItemProps } from '../../models/Product';
import { SpecialistContext } from '../../contexts/SpecialistContext';
import { toast } from 'react-toastify';
import { Specialty } from '../../models/Specialty';
import { ServiceContext } from '../../contexts/ServiceContext';
import { Page, useMainRouter } from '../../Router/pageComponents';
import { PlatformContext } from '../../contexts/PlatformContext';
import { compareResources } from '../../utils/compare';
import { envConfig } from '../../utils/enviroment';
import { ModalSpecialistIntroduction } from '../../components/ModalSpecialistIntroduction';
import { useAnalytics } from '../../hooks/useAnalytics';
import { FirebaseEvents } from '../../utils/enums/firebase-events';

const ServiceList = ({ isSDKAllowed }: any) => {
  const [serviceList, setServiceList] = React.useState<Resources[]>([]);
  const [specialistList, setSpecialistList] = React.useState<Specialist[]>([]);
  const [specialtyList, setSpecialtyList] = React.useState<Specialty[]>([]);
  const [serviceResources, setServiceResources] = React.useState<Resources[]>([]);
  const [showSearchWrapper, setShowSearchWrapper] = React.useState(false);
  const [errorSearchProduct, setErrorSearchProduct] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [loadingResources, setLoadingResources] = React.useState(false);
  const [loadingModule, setLoadingModule] = React.useState(1);
  const [loadingSpecialists, setLoadingSpecialists] = React.useState(false);
  const [typeSchedule, setTypeSchedule] = React.useState<'SPECIALISTS' | 'RESOURCES' | 'SERVICES'>('RESOURCES');
  const [selectedService, setSelectedService] = React.useState<Resources | null>(null);
  const [isSpecialistIntroModalOpen, setIsSpecialistIntroModalOpen] = React.useState(false);
  // const { goTo } = useContextSelector(RouterContext, state => state);
  const { selectedServiceId, setSeletedService } = useContextSelector(ServiceContext, state => state);
  const { isSDKAllowed: isSDKAllowedContext } = useContextSelector(PlatformContext, state => state);
  const [searchTherm, setSearchTherm] = React.useState('');

  const {
    handleSelectProduct,
    handleSelectService: handleModuleService,
    selectItemToSchedule,
    logged
  } = useContextSelector(ModuleContext, state => state);

  const { setSelectedSpecialist, setSpecialties, setSpecialists, setSelectedSpecialty, specialties, findSpecialties } =
    useContextSelector(SpecialistContext, state => state);

  const { navigate } = useMainRouter();
  const { logEvent } = useAnalytics();

  const fetchServices = async (filter: string) => {
    setErrorSearchProduct('');
    setLoadingResources(true);
    const response = await fetchActiveServices(filter);
    if (response.error) {
      console.error(response.message);
      setErrorSearchProduct('Erro ao buscar produto');
    }
    if (!response.error) {
      if (response.data.length === 0) {
        setErrorSearchProduct('Não encontramos nenhum produto.');
        setServiceResources([]);
      }

      if (response.data.length > 0) {
        const resourcesFiltered = response.data
          .filter(resource => !process.env.REACT_APP_LOGGED_SERVICES?.includes(resource.id))
          .sort(compareResources);

        if (filter === '') setServiceList(logged ? response.data : resourcesFiltered);
        else setServiceResources(logged ? response.data : resourcesFiltered);
      }
    }
    setLoadingResources(false);
  };

  const fetchServicesByExternalClient = async (value: string) => {
    const response = await fetchExternalClientServices(value);
    if (response.error) console.error(response.message);

    if (!response.error) {
      if (response.data.length === 0) {
        setServiceList([]);
        setServiceResources([]);
      }

      if (response.data.length === 1) {
        await handleResourceSchedule(response.data[0]);
      }

      if (response.data.length > 1) {
        setServiceResources(response.data);
        setServiceList(response.data);
      }
    }
    setLoadingModule(l => l - 1);
  };

  const getSpecialistsByName = async (name: string) => {
    setLoadingSpecialists(true);
    if (name.length > 2) {
      logEvent({
        eventName: FirebaseEvents.schedule_specialist_search,
        eventParams: {
          search: name
        }
      });

      const response = await fetchSpecialists({ name });
      if (response.error) {
        console.error(response.message);
        setErrorSearchProduct('Erro ao buscar especialista');
      }
      if (!response.error) {
        if (response?.data?.length === 0) {
          setErrorSearchProduct('Não encontramos nenhum especialista.');
          setSpecialistList([]);
        }
        if (response.data.length > 0) setSpecialistList(response.data);
      }
    }
    setLoadingSpecialists(false);
  };

  const openSpecialistsSearchContext = () => {
    setTypeSchedule('SPECIALISTS');
  };

  const handleResourceRoute = ({ service, product }: { service?: ServiceItemProps; product?: ProductItemProps }) => {
    if (service && !product) {
      handleModuleService(service);
      selectItemToSchedule('SERVICE');
      setSeletedService && setSeletedService(service);

      switch (service.id) {
        case process.env.REACT_APP_TELEORIENTATION_PRODUCT_ID:
          return navigate(Page.TELEMEDICINE_PA);

        case process.env.REACT_APP_CHECKUP_PRODUCT_ID:
          return navigate(Page.CHECKUP_DIGITAL_ROUTER);

        case process.env.REACT_APP_EXECUTIVE_CHECKUP_SERVICE_ID:
          return navigate(Page.CHECKUP_EXECUTIVE_ROUTER);

        case envConfig.REACT_APP_BLOOD_BANK_SERVICE_ID:
          return navigate(Page.BLOOD_BANK);

        case envConfig.REACT_APP_SERVICE_ID:
          return navigate(Page.GENERAL, { routeTo: PAGES.PATIENT_FORM.id });

        default:
          return navigate(Page.GENERAL, { routeTo: PAGES.MEDICAL_APPOINTMENT_TYPE.id });
      }
    }
    if (!service && product) {
      handleSelectProduct(product);
      selectItemToSchedule('PRODUCT');
      // goTo(PAGES.RESOURCE_DETAILS.id, { previousPage: true });
    }
  };

  const checkIsSpecialtyServices = (serviceName: string) => {
    const specialServices: { [key: string]: () => void } = {
      'MÉDICOS EINSTEIN': () => openSpecialistsSearchContext()
    };
    const specialServiceFound = specialServices[serviceName.toUpperCase()];
    if (specialServiceFound) {
      specialServiceFound();
      return true;
    }
    return false;
  };

  const handleResourceSchedule = async (resourceSchedule: Resources) => {
    if (resourceSchedule.type === 'service') {
      if (!checkIsSpecialtyServices(resourceSchedule.name)) {
        if (resourceSchedule.name === 'Check-up digital') {
          const service = await fetchCatalogService(resourceSchedule.id);
          if (!service.error) handleResourceRoute({ service: service.data });
        } else {
          const serviceResult = await fetchServiceById(resourceSchedule.id);
          if (!serviceResult.error) handleResourceRoute({ service: serviceResult.data });
        }
      }
    }
    if (resourceSchedule.type === 'product') {
      const productResult = await fetchProductById(resourceSchedule.id);
      if (!productResult.error) handleResourceRoute({ product: productResult.data });
    }
  };

  const handleSpecialtySchedule = async (specialty: Specialty) => {
    logEvent({
      eventName: FirebaseEvents.schedule_selected_speciality,
      eventParams: {
        speciality_id: specialty.id,
        speciality_name: specialty.name
      }
    });

    setLoading(true);
    setSpecialtyList([]);
    setServiceResources([]);
    const response = await fetchSpecialists({
      specialty: specialty.id,
      medical_indicator: 1
    });
    if (response.error) setErrorSearchProduct('Erro ao consultar especialistas');
    if (!response.error) {
      setSpecialists(response.data);
      setSelectedSpecialty(specialty);
      navigate(Page.GENERAL, { routerTo: PAGES.SPECIALIST_LIST.id });
      setShowSearchWrapper(false);
    }
    setLoading(false);
  };

  const handleOpenSchedule = async ({
    type,
    item
  }: {
    type: 'SPECIALTY' | 'SPECIALIST' | 'RESOURCE_SCHEDULE';
    item: Resources | Specialist | Specialty | null;
  }) => {
    if (!item) return;
    setLoading(true);

    const scheduleType: { [key: string]: () => Promise<void> } = {
      SPECIALTY: async () => {
        const specialtySchedule = item as Specialty;
        await handleSpecialtySchedule(specialtySchedule);
      },
      SPECIALIST: async () => {
        const specialist = item as Specialist;
        setLoading(true);

        logEvent({
          eventName: FirebaseEvents.schedule_selected_specialist,
          eventParams: {
            specialist_id: specialist.id,
            specialist_name: specialist.name,
            search: searchTherm
          }
        });

        const result = await fetchSpecialistById(specialist.id);

        if (!result.error) {
          setSelectedSpecialist(result.data);
          navigate(Page.GENERAL, { routeTo: PAGES.SPECIALIST_DETAILS.id });
        }
        setLoading(false);
      },
      RESOURCE_SCHEDULE: async () => {
        const resourceSchedule = item as Resources;
        await handleResourceSchedule(resourceSchedule);
      }
    };
    await scheduleType[type]();
    setLoading(false);
  };

  const handleSelectService = async (service: Resources) => {
    setSelectedService(service);

    logEvent({
      eventName: FirebaseEvents.schedule_selected_service,
      eventParams: {
        service_name: service.name,
        service_id: service.id
      }
    });

    // if (service.name === 'Médicos Einstein') setIsSpecialistIntroModalOpen(true);
  };

  const handleSubmit = () => {
    if (selectedService?.name.toUpperCase() === 'MÉDICOS EINSTEIN') {
      setSelectedSpecialty(undefined);
      setSpecialists([]);
      navigate(Page.GENERAL, { routeTo: PAGES.SPECIALIST_LIST.id });
    } else {
      handleOpenSchedule({
        type: 'RESOURCE_SCHEDULE',
        item: selectedService
      });
    }
  };

  async function getSpecialties() {
    setLoading(true);
    const result = await fetchSpecialties();
    if (result.error) toast.error('Não foi possível buscar as especialidades.');
    if (!result.error) setSpecialties(result.data);
    setLoading(false);
  }

  React.useEffect(() => {
    if (!isSDKAllowed && !isSDKAllowedContext) {
      fetchServices('');
      getSpecialties();
    } else {
      fetchServicesByExternalClient('');
    }
  }, []);

  React.useEffect(() => {
    setSpecialistList([]);
    setServiceResources([]);
  }, [typeSchedule]);

  React.useEffect(() => {
    if (selectedServiceId.length) {
      const contextSelectedResource = serviceList.find(item => item.id === selectedServiceId);
      if (contextSelectedResource) handleSelectService(contextSelectedResource);
    }
  }, [selectedServiceId, serviceList]);

  if (isSDKAllowed === true && loadingModule > 0) return <LoadingOverlay loading withBackground />;

  return (
    <ContainerPage
      standardSpacing={showSearchWrapper}
      childrenFooter={
        !showSearchWrapper && <Button title="Continuar" disabled={!selectedService?.id} onClick={handleSubmit} />
      }
    >
      <S.Container>
        <S.ListWrapper>
          {!showSearchWrapper ? (
            <>
              <HeadTitle title="O que deseja agendar?" disableBack />
              <Search
                fetchResources={value => {
                  if (!isSDKAllowed && !isSDKAllowedContext) {
                    fetchServices(value);
                    getSpecialties();
                  } else {
                    fetchServicesByExternalClient(value);
                  }
                }}
                handleClickResult={handleOpenSchedule}
                loading={loadingResources || loadingSpecialists}
                resourcesSchedule={serviceList}
                selectedService={selectedService ?? ({} as Resources)}
                handleSelectService={handleSelectService}
                standardSpacing={false}
                changeContext={() => {
                  setShowSearchWrapper(!showSearchWrapper);
                  setTypeSchedule('RESOURCES');
                }}
                type="SERVICES"
                onChangeSearchTherm={setSearchTherm}
                rounded
              />
            </>
          ) : (
            <Search
              fetchResources={filter => {
                if (!isSDKAllowed) {
                  setSpecialtyList(findSpecialties(filter));
                  if (filter.length > 2) {
                    fetchServices(filter);
                    getSpecialistsByName(filter);
                  }
                } else {
                  if (filter.length > 2) fetchServicesByExternalClient(filter);
                }
              }}
              fetchSpecialists={filter => {
                setSpecialtyList(findSpecialties(filter));
                if (filter.length > 2) getSpecialistsByName(filter);
              }}
              handleClickResult={handleOpenSchedule}
              loading={loadingResources || loadingSpecialists}
              resourcesSchedule={serviceResources}
              specialistList={specialistList}
              specialtyList={specialtyList}
              standardSpacing
              changeContext={() => {
                setShowSearchWrapper(!showSearchWrapper);
              }}
              onChangeSearchTherm={setSearchTherm}
              type={typeSchedule}
              rounded
            />
          )}
        </S.ListWrapper>
      </S.Container>
      <LoadingOverlay loading={loading} />
      <ModalSpecialistIntroduction
        buttonClosePrimary={handleSubmit}
        visible={isSpecialistIntroModalOpen}
        onClose={() => {
          setSelectedService(null);
          setIsSpecialistIntroModalOpen(false);
        }}
      />
    </ContainerPage>
  );
};

export default ServiceList;
